import React from 'react'
import cx from 'classnames'


type OrderItemBaseProps = {
  className?: string
  'data-testid': string
}

const OrderItemBase: React.CFC<OrderItemBaseProps> = (props) => {
  const { children, className, 'data-testid': dataTestId } = props

  return (
    <div className={cx(className, 'relative rounded bg-light-beige px-16 py-24')} data-testid={dataTestId}>
      {children}
    </div>
  )
}


export default OrderItemBase
